$(document).ready(function(){

  $('#loadingMask').fadeOut(1000).delay(2000);

  $('#sidr li.has-dropdown').click(function(){
    $('#sidr .sub-nav').slideToggle('fast');
  })

  $('#simple-menu').sidr();

  // Lookbook slider settings
  $('.lookbook-main-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.lookbook-thumbnails',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          arrows: false
        }
      },
      {
        breakpoint: 700,
        settings: {
          arrows: false
        }
      },
      {
        breakpoint: 550,
        settings: {
          arrows: false
        }
      }
    ]
  });
  $('.lookbook-thumbnails').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.lookbook-main-image',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
          slidesToShow: 5,
          variableWidth: false
        }
      },
      {
        breakpoint: 700,
        settings: {
          arrows: false,
          slidesToShow: 4,
          variableWidth: false
        }
      },
      {
        breakpoint: 550,
        settings: {
          arrows: false,
          slidesToShow: 2,
          variableWidth: false
        }
      }
    ]
  });


  // Homepage Hero slider settings
  $('.hero-slider').slick({
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 3,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    slide: '.slide',
    speed: 1000,
    arrows: true,
    responsive: [

      {
          breakpoint: 1000,
          settings: {
          arrows: true,
          centerMode: false,
          centerPadding: '0px',
          slidesToShow: 1,
          variableWidth: false,
        }
      }
    ]
  });



  $('.main-image-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    focusOnSelect: false,
    asNavFor: '.product-thumbnails'
  });
  $('.product-thumbnails.desktop').slick({
    slidesToShow: 5,
    asNavFor: '.main-image-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    vertical: true
  });
  $('.product-thumbnails.mobile').slick({
    slidesToShow: 20,
    slidesToScroll: 1,
    asNavFor: '.main-image-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    vertical: false
  });






        
});


